import React, { useEffect, useState } from "react";
import apiClient from "../api/apiClient";
import "../styles/DriverWithdrawals.css";

const DriverWithdrawals = () => {
  const [withdrawals, setWithdrawals] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [updating, setUpdating] = useState({});
  const [statusSelection, setStatusSelection] = useState({});

  // Fetch withdrawals
  useEffect(() => {
    const fetchWithdrawals = async () => {
      try {
        const token = localStorage.getItem("token"); // fetch token
        const response = await apiClient.get("/admin/driver-withdrawals", {
          headers: { Authorization: `Bearer ${token}` },
        });

        setWithdrawals(response.data);

        const initialStatus = {};
        response.data.forEach((item) => {
          initialStatus[item.id] = item.status;
        });
        setStatusSelection(initialStatus);
        setLoading(false);
      } catch (err) {
        setError(err.response?.data || err.message || "Something went wrong");
        setLoading(false);
      }
    };

    fetchWithdrawals();
  }, []);

  const getStatusColor = (status) => {
    switch (status) {
      case "APPROVED":
        return "green";
      case "REJECTED":
        return "red";
      case "PENDING":
        return "orange";
      default:
        return "gray";
    }
  };

  const handleDropdownChange = (id, value) => {
    setStatusSelection((prev) => ({ ...prev, [id]: value }));
  };

  const handleSubmit = async (id) => {
    const newStatus = statusSelection[id];
    setUpdating((prev) => ({ ...prev, [id]: true }));

    try {
      const token = localStorage.getItem("token"); // include token
      const response = await apiClient.put(
        `/admin/${id}/status-withdrawal?status=${newStatus}`,
        null,
        { headers: { Authorization: `Bearer ${token}` } }
      );


      setWithdrawals((prev) =>
        prev.map((w) => (w.id === id ? { ...w, status: response.data.status } : w))
      );

      alert(`Status updated to ${response.data.status}`);
    } catch (err) {
      alert("Failed to update status: " + (err.response?.data || err.message));
    } finally {
      setUpdating((prev) => ({ ...prev, [id]: false }));
    }
  };

  if (loading) return <p>Loading withdrawals...</p>;
  if (error) return <p>Error: {error}</p>;

  const statusOptions = ["PENDING", "APPROVED", "REJECTED"]; // added PENDING

  return (
    <div className="withdrawals-container">
      <h2>Driver Withdrawals</h2>
      <div className="table-wrapper">
        <table className="withdrawals-table">
          <thead>
            <tr>
              <th>ID</th>
              <th>User Name</th>
              <th>Phone</th>
              <th>Amount</th>
              <th>Account Number</th>
              <th>IFSC Code</th>
              <th>Status</th>
              <th>Request Time</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
            {withdrawals.map((item) => (
              <tr key={item.id}>
                <td>{item.id}</td>
                <td>{item.userName}</td>
                <td>{item.userPhone}</td>
                <td>{item.amount}</td>
                {/* New Fields */}
                <td>{item.accountNumber}</td>
                <td>{item.ifscCode}</td>
                <td>
                  <span
                    className="status-badge"
                    style={{ backgroundColor: getStatusColor(item.status) }}
                  >
                    {item.status}
                  </span>
                </td>
                <td>{new Date(item.requestTime).toLocaleString()}</td>
                <td>
                  <select
                    value={statusSelection[item.id]}
                    onChange={(e) => handleDropdownChange(item.id, e.target.value)}
                    disabled={updating[item.id]}
                  >
                    {statusOptions.map((status) => (
                      <option key={status} value={status}>
                        {status}
                      </option>
                    ))}
                  </select>
                  <button
                    onClick={() => handleSubmit(item.id)}
                    disabled={updating[item.id]}
                  >
                    {updating[item.id] ? "Updating..." : "Submit"}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DriverWithdrawals;
